import history from '@/services/history';
import removeUndefined, { Param } from './removeUndefined';

export function setSearchParams<T extends Param>(options: T): T {
  const filter = removeUndefined(options);
  const params = new URLSearchParams(filter).toString();
  history.push({ search: params });
  return filter as T;
}
